// Colors
export const ACTION_COLOR_DEFAULT = '#116DFF';
export const TEXT_COLOR_DEFAULT = '#000000';
export const BG_COLOR_DEFAULT = '#ffffff';
export const FALLBACK_COLOR_DEFAULT = '#000000';
export const FALLBACK_COLOR_BRIGHT_DEFAULT = '#FFFFFF';

// Desktop heading font sizes
// SYNC: must match $header*Size in wix-rich-content-common/statics/styles/consts.scss
export const HEADING_FONT_SIZES = {
  h1: '40px',
  h2: '28px',
  h3: '24px',
  h4: '20px',
  h5: '18px',
  h6: '16px',
} as const;

export const PARAGRAPH_FONT_SIZE = '16px';
